import React from 'react';
import { Box, Stack } from '@mui/material';
import { ClientDataCard } from './account-settings/ClientDataCard';
import { PasswordCard } from './account-settings/PasswordCard';
import { NotificationsCard } from './account-settings/NotificationsCard';

export const AccountSettingsDetails = () => (
  <Stack
    direction={{ xs: 'column', lg: 'row' }}
    spacing={4}
    alignItems="stretch"
  >
    <Box flex={1.7}>
      <ClientDataCard />
    </Box>

    <Box flex={0.8}>
      <PasswordCard />
    </Box>

    <Box flex={0.5}>
      <NotificationsCard />
    </Box>
  </Stack>
);
